import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import * as AppConst from "../../constants/App";
import ObjectControllerApi from '../../api/ObjectController';

class ContactOwner extends Component {
    state = {
        name: '',
        message: '',
        subject: '',
        isShowModal: false,
        recipientEmail: ''
    };

    showModal = event => {
        const {
            i18n,
            user: {
                currentUser: {
                    firstName,
                    lastName,
                    email
                }
            }
        } = this.props;
        event.preventDefault();

        let displayName = '';
        if (firstName != null) {
            displayName = firstName;
        }
        if (lastName != null) {
            displayName += " " + lastName;
        }

        this.setState({
            isShowModal: true,
            name: displayName,
            email: email,
            subject: i18n['objectPage.sendMail.subjectDefault'],
            message: ''
        });
    };

    handleChange = event => {
        const newState = {};
        newState[event.currentTarget.name] = event.currentTarget.value;

        this.setState(newState);
    };

    handleDateStartChange = date => {
        this.setState({dateArrival: date})
    };

    handleDateEndChange = date => {
        this.setState({dateDeparture: date});
    };

    hideModal = isNeedSendMail => {
        if (isNeedSendMail) {
            let objectId = this.props.objectPage.currentObject.id;
            const {email, name, message, phone, dateArrival, dateDeparture} = this.state;

            ObjectControllerApi.contactOwner(objectId, {
                email: email,
                name: name,
                message: message,
                phone: phone,
                dateArrival: dateArrival.format(AppConst.DATE_FORMAT),
                dateDeparture: dateDeparture.format(AppConst.DATE_FORMAT)
            });
        }

        this.setState({isShowModal: false});
    };

    isSendDisabled = () => {
        const {email, name, message, phone, dateArrival, dateDeparture} = this.state;

        return (name === '' || email === '' || message === '' || phone === '' || dateArrival === undefined || dateDeparture === undefined)
    };

    render() {
        const {isShowModal, email, name, message, phone, dateArrival, dateDeparture} = this.state;
        const {i18n, code} = this.props;

        return (
            <div style={{paddingTop: '10px'}}>
                <a href="" onClick={this.showModal} className="btn-border">
                    <i className="send"/>
                    <span>Contact Owner</span>
                </a>
                <ReactModal
                    isOpen={isShowModal}
                    className="custom-react-modal contact-owner"
                    overlayClassName="custom-react-modal-overlay"
                >
                    <form className="light">
                        <label>
                            Your Name:
                            <input
                                name='name'
                                value={name}
                                onChange={this.handleChange}
                            />
                        </label>

                        <label>
                            Your Email:
                            <input
                                type="email"
                                name='email'
                                value={email}
                                onChange={this.handleChange}
                            />
                        </label>

                        <label>
                            Your Phone *:
                            <input
                                name="phone"
                                value={phone}
                                onChange={this.handleChange}
                            />
                        </label>

                        <label>
                            Message *:
                            <textarea
                                name="message"
                                value={message}
                                onChange={this.handleChange}
                            />
                        </label>

                        <div className="sidebar-dates">
                            <div className="flex">
                                <span className="to-date">
                                    {code !== undefined && <DatePicker
                                        locale={code}
                                        selected={dateArrival}
                                        openToDate={dateArrival === undefined ? dateDeparture : undefined}
                                        dateFormat={AppConst.DATE_FORMAT}
                                        onChange={this.handleDateStartChange}
                                        placeholderText={i18n['objectPage.dateStartPlaceholder']}
                                    />}
                                </span>

                                <span className="from-date">
                                    {code !== undefined && <DatePicker
                                        locale={code}
                                        selected={dateDeparture}
                                        openToDate={dateDeparture === undefined ? dateArrival : undefined}
                                        dateFormat={AppConst.DATE_FORMAT}
                                        onChange={this.handleDateEndChange}
                                        placeholderText={i18n['objectPage.dateEndPlaceholder']}
                                    />}
                                </span>
                            </div>

                        </div>
                    </form>

                    <br/><br/>

                    <button onClick={() => this.hideModal(false)} className="btn btn-border">
                        Close
                    </button>

                    <button onClick={() => this.hideModal(true)} className="btn" disabled={this.isSendDisabled()}>
                        Send
                    </button>
                </ReactModal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    i18n: state.languages.i18n,
    code: state.languages.currentLanguage.code,
    objectPage: state.objectPage,
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactOwner));



// WEBPACK FOOTER //
// ./src/components/PropertyPage/ContactOwner.js